import SenceSupervisionInfo  from './SenceSupervisionInfo.vue'
export default SenceSupervisionInfo
